// @flow
import { Map }     from 'immutable';
import { Reducer } from '../../Reducer';
import {
    simpleOnGetFail,
    simpleOnGetRequest,
    simpleOnGetSuccess,
    simpleOnItemCreateDone,
    simpleOnItemCreateFail,
    simpleOnItemCreateRequest,
    simpleOnItemCreateSuccess,
    simpleOnItemLoadFail,
    simpleOnItemLoadRequest,
    simpleOnItemLoadSuccess,
    simpleOnItemUpdateDone,
    simpleOnItemUpdateFail,
    simpleOnItemUpdateRequest,
    simpleOnItemUpdateSuccess,
}                  from '../../utils';
import * as TYPES  from './types';

const DEFAULT_STATE = Map({
    busy:  false,
    error: null,
    items: [],
    item:  null,
});

export default class PackagesReducer extends Reducer {
    NAME = 'Packages';

    alias = {
        [ TYPES.PACKAGES_GET_REQUEST ]: 'onGetRequest',
        [ TYPES.PACKAGES_GET_SUCCESS ]: 'onGetSuccess',
        [ TYPES.PACKAGES_GET_FAIL ]:    'onGetFailure',

        [ TYPES.PACKAGE_CREATE_REQUEST ]: 'onItemCreateRequest',
        [ TYPES.PACKAGE_CREATE_SUCCESS ]: 'onItemCreateSuccess',
        [ TYPES.PACKAGE_CREATE_FAIL ]:    'onItemCreateFailure',
        [ TYPES.PACKAGE_CREATE_DONE ]:    'onItemCreateDone',

        [ TYPES.PACKAGE_LOAD_REQUEST ]: 'onItemLoadRequest',
        [ TYPES.PACKAGE_LOAD_SUCCESS ]: 'onItemLoadSuccess',
        [ TYPES.PACKAGE_LOAD_FAIL ]:    'onItemLoadFailure',

        [ TYPES.PACKAGE_UPDATE_REQUEST ]: 'onItemUpdateRequest',
        [ TYPES.PACKAGE_UPDATE_SUCCESS ]: 'onItemUpdateSuccess',
        [ TYPES.PACKAGE_UPDATE_FAIL ]:    'onItemUpdateFailure',
        [ TYPES.PACKAGE_UPDATE_DONE ]:    'onItemUpdateDone',
    };

    /**
     *
     * @param state
     * @param payload
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onGetRequest = simpleOnGetRequest(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onGetSuccess = simpleOnGetSuccess(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onGetFailure = simpleOnGetFail(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param payload
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemLoadRequest = simpleOnItemLoadRequest(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemLoadSuccess = simpleOnItemLoadSuccess(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemLoadFailure = simpleOnItemLoadFail(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param payload
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemCreateRequest = simpleOnItemCreateRequest(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemCreateSuccess = simpleOnItemCreateSuccess(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemCreateFailure = simpleOnItemCreateFail(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemCreateDone = simpleOnItemCreateDone(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param payload
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemUpdateRequest = simpleOnItemUpdateRequest(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemUpdateSuccess = simpleOnItemUpdateSuccess(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemUpdateFailure = simpleOnItemUpdateFail(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemUpdateDone = simpleOnItemUpdateDone(DEFAULT_STATE);

}
